import {Component, Input, ViewEncapsulation} from '@angular/core';
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {DataSource} from "../../../interfaces/data-source";
import {Serializer} from "../../../interfaces/serializer";
import {Site} from "../../../interfaces/site";
import {NotificationTrackingUrlsTemplateStore} from "./notification-tracking-urls-template.store";

@Component({
  selector: 'app-notification-tracking-urls-template',
  templateUrl: './notification-tracking-urls-template.component.html',
  styleUrls: ['./notification-tracking-urls-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [NotificationTrackingUrlsTemplateStore]
})
export class NotificationTrackingUrlsTemplateComponent {
  @Input('notification') public set set_notification(notification: NotificationComponentObject) {
    this.notification = notification;
    this.parameters = notification.payload.relationships.notification_datas.data.map(item => item.attributes.data);
    this.data_source = notification.payload.relationships.models.data.find(item => item.type === 'data_source');
    this.data_set_usage = notification.payload.relationships.models.data.find(item => item.type === 'data_set_usage');
    this.data_set = notification.payload.relationships.data_set.data;
  }

  public notification: NotificationComponentObject;
  public parameters: any[] = []
  public data_source: Serializer<DataSource>;
  public data_set_usage: Serializer<DataSource>;
  public data_set: Serializer<Site>;

  constructor(
    private readonly _notificationTrackingUrlsTemplateStore: NotificationTrackingUrlsTemplateStore
  ) { }

  public onAddTrackingClick(): void {
    this._notificationTrackingUrlsTemplateStore.onAddTrackingClick({
      site: this.data_set,
      data_set_usage: this.data_set_usage,
      data_source: this.data_source,
      notification: this.notification
    });
  }
}
